export default __webpack_public_path__ + "static/media/ic-minimum-attendance.a3c658f2.svg";